var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRepeat = function SvgRepeat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.564 4.865A8.333 8.333 0 1 0 18.334 10 .833.833 0 0 1 20 10c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0a9.99 9.99 0 0 1 8.021 4.028l.34-1.27a.833.833 0 0 1 1.61.43l-.863 3.221a.833.833 0 0 1-1.02.59l-3.22-.863a.833.833 0 1 1 .431-1.61z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1 6.323a.73.73 0 0 0-1.46 0v4.246c0 .153.047.302.137.426l2.236 3.109a.731.731 0 0 0 1.187-.854l-2.1-2.917z"
  })));
};
export default SvgRepeat;